<template>
  <v-container
    id="priority-setting-profile"
    fluid
    tag="section"
    style="background-color: white"
  >
    <div class="text-sm-right mb-4 d-flex justify-space-between">
      <filter-form
          :productGroupList="productGroupList"
          :contactSourceList="contactSourceList"
          :filter-form="filterForm"/>
<!--      <v-btn-->
<!--          v-if="checkAuthorization('priority-setting_create')"-->
<!--          class="primary mx-0"-->
<!--          @click="addNewPrioritySetting"-->
<!--      >-->
<!--        <v-icon>mdi-plus</v-icon>Thêm Mới-->
<!--      </v-btn>-->
    </div>
    <div>
      <v-tabs
          v-model="tab"
          grow
          @change="getPrioritySettingFilter()">
        <v-tabs-slider></v-tabs-slider>

        <v-tab
          v-for="(item, key) in tabs"
          :key="key"
        >
          {{item}}
        </v-tab>

        <v-tab-item
            v-for="(item, key) in tabs"
            :key="key">
          <priority-setting-table
            v-if="prioritySettings.length"
            :filter-form="filterForm"
            :prioritySettings="prioritySettings"
            :productGroupList="productGroupList"
            :contactSourceList="contactSourceList"
          />
          <common-no-result
            v-else
          />

          <!--Paging nation-->
          <div class="pb-3">
            <v-col cols="12" md="12" class="pb-0"
                   style="display: flex; justify-content: flex-end; padding: 0 12px">
              <div class="text-right mb-1 mt-2">
                {{ showIndex() }}
                <v-btn
                    small
                    class="pagination-btn-left"
                    @click="function() { currentPage--; pendingPage--; }"
                    :disabled="currentPage == 1">
                  <v-icon>mdi-menu-left</v-icon>
                </v-btn>
                <v-btn
                    :disabled="prioritySettings.length < limit"
                    small
                    class="pagination-btn-right"
                    @click="function() { currentPage++; pendingPage++; }">
                  <v-icon>mdi-menu-right</v-icon>
                </v-btn>
              </div>
              <div style="width: 35px">
                <v-text-field
                    :readonly="prioritySettings.length < limit"
                    class="pt-0"
                    v-model="pendingPage"
                    min="1"
                    step="1"
                    type="number"
                    @input="applyPendingPage()">
                </v-text-field>
              </div>
            </v-col>
          </div>
        </v-tab-item>
      </v-tabs>
    </div>
    <priority-setting-form
        :productGroupList="productGroupList"
        :contactSourceList="contactSourceList"
    />
  </v-container>
</template>

<script>
  import FilterForm from './components/FilterForm.vue'
  import PrioritySettingTable from './components/PrioritySettingTable'
  import PrioritySettingForm from './components/PrioritySettingForm'
  import RepositoryFactory from '../../repositories/RepositoryFactory'
  const PrioritySettingRepository = RepositoryFactory.get('priority_setting');
  const ContactSourceRepository = RepositoryFactory.get('contact_source')
  const ProductGroupRepository = RepositoryFactory.get('product_group')
  export default {
    components: {
      PrioritySettingTable,
      FilterForm,
      PrioritySettingForm
    },
    data () {
      return {
        filterForm: {},
        currentPage: 1,
        limit: 10,
        totalItem: 0,
        prioritySettings: [],
        loading: false,
        tabs: ['ƯU TIÊN', 'TẤT CẢ'],
        tab: 0,
        productGroupList: [],
        contactSourceList: [],
        pendingPage: 1
      }
    },
    watch: {
      currentPage: {
        handler () {
          this.getPrioritySettingList()
        },
      },
      limit: {
        handler () {
          if (this.currentPage === 1) {
            this.getPrioritySettingList()
          } else {
            this.currentPage = 1
          }
        },
      },
    },
    async created () {
      await Promise.all([
        this.getPrioritySettingList(),
        this.getProductGroupList(),
        this.getContactSourceList()
      ])
      Bus.$on('priority-setting-list-filter', (filterForm) => {
        this.filterForm = filterForm
        this.getPrioritySettingFilter()
      })
      Bus.$on('priority-setting-list-reload', () => {
        this.getPrioritySettingList()
      })
    },
    beforeDestroy () {
      Bus.$off('priority-setting-list-filter')
      Bus.$off('priority-setting-list-reload')
    },
    methods: {
      async getPrioritySettingList () {
        this.loading = true
        const params = {
          limit: this.limit,
          page: this.currentPage - 1,
          productGroupId: this.filterForm.productGroupId,
          contactSourceId: this.filterForm.contactSourceId,
          priority: this.filterForm.priority,
          type: this.tab == 0 ? 'priority' : undefined
        }
        this.appLoadingData(true)
        const response = await PrioritySettingRepository.list(params)
        this.appLoadingData(false)
        this.loading = false
        if (response.success) {
          this.prioritySettings = _.get(response, 'data', []).map(u => ({
            ...u,
            showEdit: {
              priority: false
            },
            stt: (this.currentPage - 1)*this.limit
          }))
          this.totalItem = response.totalItem
        }
      },
      async getContactSourceList () {
        const response = await ContactSourceRepository.list({
          limit: 1000
        })
        if (_.get(response, 'success', false)) {
          this.contactSourceList = _.get(response, 'data')
        }
      },
      async getProductGroupList() {
        const params = {
          limit: 1000,
          status: 'active'
        }
        const response = await ProductGroupRepository.list(params);
        if (response.success) {
          this.productGroupList = _.get(response, 'data', [])
        }
      },
      addNewPrioritySetting () {
        Bus.$emit('priority-setting-show-form', {})
      },
      showIndex() {
        if (this.prioritySettings.length > 0) {
          let maxIndex = this.prioritySettings.length < this.limit ? parseInt(this.currentPage - 1) * parseInt(this.limit) + this.prioritySettings.length : parseInt(this.currentPage) * parseInt(this.limit)
          return this.prioritySettings.length < this.limit ? (maxIndex - parseInt(this.prioritySettings.length) + 1) + ' - ' + maxIndex : (maxIndex - parseInt(this.limit) + 1) + ' - ' + maxIndex
        } else {
          return ('0 - 0')
        }
      },
      applyPendingPage: _.debounce(function() {
        this.currentPage = parseInt(this.pendingPage)
        return
      }, 500),
      getPrioritySettingFilter() {
        this.currentPage = 1
        this.pendingPage = 1
        this.getPrioritySettingList()
      }
    },
  }
</script>

<style scoped>
  .pagination-btn-left, .pagination-btn-right {
    max-width: 30px !important;
    min-width: 30px !important;
    background-color: #ffffff !important;
  }
  .pagination-btn-left i, .pagination-btn-right i {
    color: rgba(0, 0, 0, 0.54) !important;
  }
  .pagination-btn-left {
    margin: 0px 5px 2px 10px !important;
  }
  .pagination-btn-right {
    margin: 0px 10px 2px 5px !important;
  }
</style>
